(function() {
    'use strict';

    window.Coop = window.Coop || { Modules: {} };

    Coop.Modules.LocationsList = {
        init: function() {
            window.locationsList = this;
            this.$listContainer = $('.finder-results-list');
            this.is_colleague = $('body').hasClass('colleague-finder');
            this.business = window.SEARCH_BUSINESS;
            this.base_url = window.SEARCH_URL;
            this.template = this.getTemplate();

            if (this.$listContainer.find('.store-item').length !== 0) {
                $('.finder-form').addClass('finder-form-compact');
                $('body').removeClass('finder-landing').addClass('list-view');

                Coop.Modules.FeedbackWrongInfo.init();

                $('.toggle-trigger', this.$listContainer)
                    .attr('aria-expanded', 'false');
                $('.toggle-content', this.$listContainer)
                    .attr('aria-hidden', 'true')
                    .hide();

                this.bindEvents();
                Coop.Modules.AppHeight.fitLayout();
            }
        },
        clearList: function() {
            this.$listContainer.empty();
        },
        populateList: function(results) {
            var start = $('.store-item', this.$listContainer).length;

            if (results.length) {
                const prevLength = $('li', this.$listContainer).length;

                if (!$('> ul', this.$listContainer).length) {
                    $('<ul aria-live="polite" aria-label="Your results have been updated"></ul>').appendTo(this.$listContainer);
                }

                if (prevLength === 0) {
                    $('> ul', this.$listContainer).append('<h2 class="coop-t-h3">Funeral home search results</h2>');
                }

                $('li.more-results', this.$listContainer).remove();

                for (var i = 0; i < results.length; i++) {
                    var $store = $('<li></li>').addClass('store-item'),
                        storeInfo = this.renderListItem(results[i], i + start);
                    $store.html(storeInfo);
                    $('> ul', this.$listContainer).append($store);
                }

                this.$listContainer.find('.toggle-content').hide();
                Coop.Modules.FeedbackWrongInfo.init();

                $('> ul', this.$listContainer).append('<li class="more-results"><a href="#" class="btn btn-primary">View more results +</a></li>');

                if (prevLength > 0) {
                    $('.store-name a', this.$listContainer).get(prevLength - 1).focus();
                }

                this.bindEvents();
            }
        },
        renderListItem: function(result, index) {
            var openingHours = this.processOpeningHours(result.opening_hours),
                currentLocation = Coop.Modules.Geolocator.currentLocation,
                data = {
                    index: index + 1,
                    colleague_finder: this.is_colleague,
                    store_url: result.url,
                    store_name: result.name,
                    store_society: result.society,
                    store_address: this.formatAddress(result, "\n", 'span'),
                    store_distance_metres: Math.ceil(result.distance.m),
                    store_distance_miles: Math.round((result.distance.m / 1609.34) * 100) / 100,
                    store_today_hours: result.open_status_label,
                    store_latlon: result.position.y + ',' + result.position.x,
                    current_location: currentLocation,
                    store_phone: result.phone,
                    store_hours: result.opening_hours.length > 0,
                    hours_available: result.opening_hours.filter(function(day) { return day.label !== null; }).length > 0,
                    premise: 'funeral\xa0home',
                    store_website: result.website,
                    encoded_address: encodeURIComponent(this.formatAddress(result, ', ', false)),
                    enable_enquiries: window.ENABLE_ENQUIRIES ? 'true' : 'false',
                    contact_choices: window.CONTACT_CHOICE ? 'true' : 'false',
                    email_us_link: this.base_url + '/email-us/' + result.cedar,
                    call_back_link: this.base_url + '/ask-us-to-call-you/' + result.cedar,
                    notify_us_link: this.base_url + '/notify-us-of-a-death/' + result.cedar,
                    at_need_form_link: this.base_url + '/start-a-funeral-arrangement/?branch=' + result.cedar,
                    store_feedback: window.DOORBELL_ID
                };

            if (this.is_colleague) {
                data.store_opening_hours = this.compactOpeningTimes(openingHours);
            }
            return nunjucks.render(this.template, data);
        },
        bindEvents: function() {
            var self = this;

            this.$listContainer
                .off('click.storeItem', '.store-item div')
                .on('click.storeItem', '.store-item div', function(e) {

                    if (!$(e.target).is('a') && !$(e.target).is('strong')) {
                        var pk = $(this).data('store-id');
                        e.preventDefault();
                        if ($(this).hasClass('is_active')) {
                            self.closePanel(pk);
                        }
                        else {
                            self.openPanel(pk);
                        }
                    }
                });

            this.$listContainer
                .off('click.moreResults', '.more-results a')
                .on('click.moreResults', '.more-results a', function(e) {
                    if ($(this).hasClass('btn-loading')) {
                        e.preventDefault();
                        return;
                    } else {
                        e.preventDefault();
                        $(this).addClass('btn-loading');
                        locationSearch.widenSearch();
                    }
                });


            this.$listContainer
                .off('mouseover.locationsList focus.locationsList', '[data-store-id]')
                .on('mouseover.locationsList focus.locationsList', '[data-store-id]', function(e) {
                    var marker = locationsMap.getMarker($(this).data('storeId'));
                    if (marker) {
                        locationsMap.highlightMarker(marker);
                    }
                });

            this.$listContainer
                .off('mouseleave.locationsList blur.locationsList', '[data-store-id]')
                .on('mouseleave.locationsList blur.locationsList', '[data-store-id]', function(e) {
                    locationsMap.leaveMarker();
                });

        },
        formatAddress: function(result, separator, tag) {
            var addressComponents = [
                result.street_address,
                result.street_address2,
                result.street_address3,
                result.town,
                result.postcode
            ],
                address = [],
                component;

            for (var i = 0; i < addressComponents.length; i++) {
                component = addressComponents[i].replace(/(^\s+|\s+$)/g, '');
                if (component.length) {
                    if (tag) {
                        address.push('<' + tag + '>' + component + '</' + tag + '>');
                    }
                    else {
                        address.push(component);
                    }
                }
            }

            return address.join(separator);
        },
        processOpeningHours: function(openingHours) {
            // TODO: handle seasonal hours
            var storeHours = {
                'Monday': { 'name': 'Monday' },
                'Tuesday': { 'name': 'Tuesday' },
                'Wednesday': { 'name': 'Wednesday' },
                'Thursday': { 'name': 'Thursday' },
                'Friday': { 'name': 'Friday' },
                'Saturday': { 'name': 'Saturday' },
                'Sunday': { 'name': 'Sunday' }
            };

            for (var i = 0; i < openingHours.length; i++) {
                var day = openingHours[i];

                if (storeHours.hasOwnProperty(day.name)) {
                    storeHours[day.name].label = day.label;
                }
            }

            return storeHours;
        },
        compactOpeningTimes: function(openingHours) {
            if (!openingHours.Monday.label) {
                return false;
            }

            if (openingHours.Tuesday.label === openingHours.Monday.label &&
                openingHours.Wednesday.label === openingHours.Monday.label &&
                openingHours.Thursday.label === openingHours.Monday.label &&
                openingHours.Friday.label === openingHours.Monday.label) {

                if (openingHours.Saturday.label === openingHours.Monday.label) {
                    if (openingHours.Sunday.label === openingHours.Monday.label) {
                        return [{ 'name': 'Open every day', 'label': openingHours.Monday.label }];
                    }

                    return [
                        { 'name': 'Monday to Saturday', 'label': openingHours.Monday.label },
                        openingHours.Sunday
                    ];
                }

                if (openingHours.Saturday.label === openingHours.Sunday.label) {
                    return [
                        { 'name': 'Monday to Friday', 'label': openingHours.Monday.label },
                        { 'name': 'Saturday and Sunday', 'label': openingHours.Saturday.label }
                    ];
                }

                return [
                    { 'name': 'Monday to Friday', 'label': openingHours.Monday.label },
                    openingHours.Saturday,
                    openingHours.Sunday
                ];
            }

            return [
                openingHours.Monday,
                openingHours.Tuesday,
                openingHours.Wednesday,
                openingHours.Thursday,
                openingHours.Friday,
                openingHours.Saturday,
                openingHours.Sunday
            ];
        },
        fullOpeningTimes: function(openingHours) {
            var openingDays = this.compactOpeningTimes(openingHours),
                list = '<ul class="store-hours">';

            for (var day in openingDays) {
                if (openingDays.hasOwnProperty(day) && openingDays[day].label !== null) {
                    list += '<li><span class="day">' + openingDays[day].name + ':</span> <span class="hours">' + openingDays[day].label + '</span></li>';
                }
            }

            list += '</ul>';

            return list;
        },
        openPanel: function(markerIndex, skipSelectMarker) {
            var $panel = $('[data-store-id=' + markerIndex + ']');
            var $target = $('#store-' + markerIndex);

            if ($panel.hasClass('is_active')) {
                return;
            }

            this.closePanel(null, skipSelectMarker);

            var parent = $panel.parent();
            parent.addClass('is_active');

            $panel.addClass('is_active');
            $panel.attr('role', 'status');
            $target.attr('aria-hidden', 'false').slideDown(250);

            this.scrollToPanel(markerIndex);

            if (typeof window.locationsMap !== 'undefined') {
                var marker = locationsMap.getMarker(markerIndex);

                if (!skipSelectMarker) {
                    locationsMap.selectMarker(marker);
                }
            }
        },
        closePanel: function(pk, skipSelectMarker) {
            var $panel = pk ? $('[data-store-id=' + pk + ']') : $('[data-store-id]', this.$listContainer),
                $target = pk ? $('#store-' + pk) : $('.store-details', this.$listContainer);

            var parent = $panel.parent();
            parent.removeClass('is_active');

            $panel.removeClass('is_active');
            $target.attr('aria-hidden', 'true').slideUp(250);

            if (typeof window.locationsMap !== 'undefined' && !skipSelectMarker) {
                locationsMap.deselectCurrentMarker();
            }
        },
        scrollToPanel: function(markerIndex) {
            var $store = $('[data-store-id=' + markerIndex + ']').closest('.store-item'),
                $previousTriggers = $store.prevAll('.store-item').find('.store-header'),
                offset = 5,
                itemPadding = parseInt($('.store-item:first').css('padding-top')) +
                    parseInt($('.store-item:first').css('padding-bottom')) +
                    parseInt($('.store-item:first').css('margin-bottom'));

            itemPadding += 2;

            $previousTriggers.each(function() {
                offset += $(this).outerHeight() + itemPadding;
            });

            if ($(window).innerWidth() >= 750) {
                this.$listContainer.animate({ scrollTop: offset }, 250);
            }

            $store.focus();
        },
        getTemplate: function() {
            return (this.is_colleague) ? 'branch_card_colleague.html' : 'branch_card.html';
        }
    };
})();
